import { createInjectionToken } from 'ngxtension/create-injection-token';
import { Subject } from 'rxjs';

export function eventFactory<TEvent>() {
    const [injectSubject] = createInjectionToken(() => new Subject<TEvent>());
    const [injectEmitter] = createInjectionToken(() => {
        const subject = injectSubject();
        return (value: TEvent) => subject.next(value);
    });
    const [injectEvent] = createInjectionToken(() => {
        const subject = injectSubject();
        return subject.asObservable();
    });
    return [injectEvent, injectEmitter] as const;
}
